import { useClickOutside } from '@mantine/hooks'
import _ from 'lodash'
import Image from 'next/image'
import { FC, MouseEvent } from 'react'

export interface IShareItem {
  imgSrc: string
  title: string
  onShareHandler: (e?: MouseEvent<HTMLDivElement> | undefined) => void
  id: string
}

interface ISharebox {
  shareList: IShareItem[]
  onClose: () => void
}

const Sharebox: FC<ISharebox> = ({ shareList, onClose }) => {
  const shareboxOutsideRef = useClickOutside<HTMLDivElement>(() => onClose(), null)
  return (
    <div
      ref={shareboxOutsideRef}
      className="absolute right-0 top-9 z-30 rounded-lg border bg-white p-6"
      style={{ boxShadow: ' 0px 0px 20px 0px rgba(0, 0, 0, 0.1)' }}>
      <dl>
        {shareList.map(({ imgSrc, title, onShareHandler, id }, idx) => {
          const isFirst = _.isEqual(idx, 0)
          return (
            <div
              id={id}
              key={title}
              className={`flex cursor-pointer ${isFirst ? '' : 'mt-4'}`}
              onClick={onShareHandler}>
              <dt className="relative">
                <Image src={imgSrc} width={40} height={40} alt={`${title} 아이콘`} />
              </dt>
              <dd className="ml-4 flex items-center">
                <span className="font-normal">{title}</span>
              </dd>
            </div>
          )
        })}
      </dl>
    </div>
  )
}

export default Sharebox
